(window.SimilarItems = function (Behaviors) {

  "use strict";
  
  function SimilarItems(elem) {
    Behaviors.init(SimilarItems, this, arguments)

    this.similarItemsSlider = this.$elem[0];

    let itemCount = this.similarItemsSlider.querySelectorAll('.grid-item').length;

    if (itemCount > 1) {
      const SimilarItemsSwiper = new Swiper(this.similarItemsSlider, {
        wrapperClass: 'product__list',
        slideClass: 'grid-item',
        speed: 500,
        navigation: {
          nextEl: ".similar-items .swiper-button-next",
          prevEl: ".similar-items .swiper-button-prev",
        },
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 'auto',
            spaceBetween: 10,
            loop: true
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
            loop: true
          },
          1025: {
            slidesPerView: 4,
            spaceBetween: 24,
            loop: false
          }
        }
      });
    } else {
      document.querySelector('.similar-items').style.display = "none";
    }
  }

  Behaviors.inherit(SimilarItems, Behaviors.Behavior);
  SimilarItems.QUERY = '.similar-items__container';

  Behaviors.register_behavior(SimilarItems);
  
  return SimilarItems;

  }(window.Behaviors));